<template>
  <span id="app">
    <v-tooltip bottom>
      <template #activator="{ on }">
        <v-chip
          v-on="on"
          :outlined="outlined"
          :dark="dark"
          label
          small
          @click="visualizarDocumento(documento)"
          color="primary"
          class="py-4 my-1 mr-2"
          :text="text"
        >
          <v-icon small class="mr-1">{{ icon }}</v-icon>
          <span>
            {{ textButton }}
          </span>
        </v-chip>
      </template>
      <span>Clique para visualizar o documento em .PDF</span>
    </v-tooltip>

    <v-dialog
      v-model="dialog"
      width="80%"
      scrollable
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card tile>
        <v-toolbar dark color="primary lighten-1" elevation="0" tile>
          <v-toolbar-title> {{ textTitle || textButton }} </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="pa-0">
          <v-row no-gutters>
            <v-col
              v-if="relacionados.length"
              cols="3"
              style="background-color: rgb(46,97,153)"
            >
              <v-list two-line color="primary lighten-1" dark class="pt-0">
                <v-subheader>
                  Documentos relacionados
                </v-subheader>

                <v-list-item-group v-model="selected">
                  <div
                    v-for="(item, index) in relacionados"
                    v-bind:key="item.title"
                  >
                    <v-list-item
                      :key="item.title"
                      @click="showDocumento(item.edoc)"
                    >
                      <template v-slot:default="{}">
                        <v-list-item-avatar>
                          <v-icon large>mdi-file-pdf</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ item.nometipodocumento }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            E-DOC {{ item.edoc }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </v-list-item>

                    <v-divider
                      v-if="index < relacionados.length - 1"
                      :key="index"
                    ></v-divider>
                  </div>
                </v-list-item-group>
                <v-list-item-group v-if="relacionados.length > 1">
                  <v-list-item @click="download">
                    <v-list-item-avatar>
                      <v-icon large>mdi-cloud-download</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>
                        BAIXAR TODOS
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        Clique para fazer o dowload
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
            <v-col style="background-color: rgb(82, 86, 89)">
              <div v-if="obj" v-html="obj"></div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
import Vue from "vue";
import _ from "lodash";
let downloadjs = require("downloadjs");

export default {
  props: {
    edoc: { type: String },
    textButton: { type: String },
    textTitle: { type: String },
    icon: { type: String },
    text: { type: Boolean, default: false },
    outlined: { type: Boolean, default: true },
    dark: { type: Boolean, default: false },
    showEdoc: { type: Boolean, default: false },
    documento: { type: Object },
    documentosRelacionados: { type: Array }
  },
  data() {
    return {
      dialog: false,
      obj: null,
      selected: null,
      flagSelected: false,
      relacionados: []
    };
  },
  methods: {
    download() {
      Vue.axios({
        method: "post",
        url:
          process.env.VUE_APP_URL_ETCDF + "/publico/documentos/merged_base64",
        data: { relacionados: this.relacionados },
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        downloadjs(atob(response.data), "jurisprudencia", "application/pdf");
      });
    },
    visualizarDocumento(documento) {
      if (documento) {
        this.relacionados = [];
        this.relacionados.push({
          edoc: this.edoc,
          nometipodocumento: documento.nometipodocumento
            ? documento.nometipodocumento
            : "DECISÃO"
        });

        if (documento && documento.idtiporelatoriovoto) {
          this.relacionados.push({
            edoc: this.documento.edocrelatoriovoto,
            nometipodocumento: this.documento.dsctipovoto
          });
        }
      }

      if (this.documentosRelacionados) {
        this.relacionados = this.documentosRelacionados;
      }

      this.dialog = true;
      if (this.relacionados) {
        const rel = _.findKey(this.relacionados, { edoc: this.edoc });
        this.selected = parseInt(rel);
      }

      this.showDocumento(this.edoc);
    },
    showDocumento(edoc) {
      Vue.axios({
        method: "get",
        url:
          process.env.VUE_APP_URL_ETCDF +
          "/publico/documentos/" +
          edoc +
          "/base64",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        this.obj = document.createElement("object");
        this.obj.style.width = "100%";
        this.obj.style.height = window.innerHeight - 269 + "pt";
        this.obj.type = "application/pdf";

        let file = this.base64toBlob(response.data, "application/pdf");
        let fileURL = URL.createObjectURL(file);

        this.obj.data = fileURL;
        this.obj = this.obj.outerHTML;
      });
    },
    base64toBlob(base64Data, contentType) {
      contentType = contentType || "";
      let byteCharacters = atob(base64Data);
      let bytesLength = byteCharacters.length;
      let sliceSize = 1024;
      let slicesCount = Math.ceil(bytesLength / sliceSize);
      let byteArrays = new Array(slicesCount);

      for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        let begin = sliceIndex * sliceSize;
        let end = Math.min(begin + sliceSize, bytesLength);

        let bytes = new Array(end - begin);
        for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
          bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
      }
      return new Blob(byteArrays, { type: contentType });
    }
  }
};
</script>
